// src/app/quill-setup.ts
import Quill from 'quill';
import TableUp, {
  TableVirtualScrollbar,
  TableAlign,
  TableResizeLine,
  TableResizeScale,
  TableSelection,
  TableMenuContextmenu,
} from 'quill-table-up';
// import BlotFormatter from 'quill-blot-formatter';
import BlotFormatter from 'quill-blot-formatter';

// use moduleName values the package actually exposes
const tableModuleName = (TableUp as any).moduleName || 'table-up';
const tableSelectionName = (TableSelection as any).moduleName || 'table-selection';

Quill.register(`modules/table-up`, TableUp, true);
Quill.register(`modules/table-up/table-selection`, TableSelection, true);
Quill.register(`modules/table-up/table-virtual-scrollbar`, TableVirtualScrollbar, true);
Quill.register(`modules/table-up/table-align`, TableAlign, true);
Quill.register(`modules/table-up/table-resize-line`, TableResizeLine, true);
Quill.register(`modules/table-up/table-resize-scale`, TableResizeScale, true);
Quill.register(`modules/table-up/table-menu-contextmenu`, TableMenuContextmenu, true);

// Register other modules after table registration
// Quill.register('modules/blotFormatter', BlotFormatter, true);
// Quill.register('modules/blotFormatter2', BlotFormatter);

const moduleKey = 'blotFormatter2';

console.log('Registering BlotFormatter as', moduleKey, BlotFormatter);
Quill.register(`modules/${moduleKey}`, BlotFormatter, true);

// console.log('BlotFormatter raw:', BlotFormatter);
// console.log('BlotFormatter.default:', (BlotFormatter as any).default);
// console.log('BlotFormatter.moduleName:', (BlotFormatter as any).moduleName);

// Font whitelist (optional)
const Font: any = Quill.import('formats/font');
Font.whitelist = ['poppins', 'calibri', 'serif', 'monospace'];
Quill.register(Font, true);

const Size: any = Quill.import('formats/size');
Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px', '24px', '28px', '32px'];
Quill.register(Size, true);

// console.log('TableUp module registered as:', tableModuleName);
// console.log('Check:', Quill.import(`modules/${tableModuleName}`));


export const TABLE_UP_CONFIG = {
  customSelect: true,
  modules: [
    { module: TableVirtualScrollbar },
    { module: TableAlign },
    { module: TableResizeLine },
    { module: TableResizeScale, options: { blockSize: 12 } },
    { module: TableSelection },
    { module: TableMenuContextmenu, options: { tipText: true } },
  ],
};
